import { InteractionStepType } from '@scale/shared/types/chat';
import StepDescriptor from './StepDescriptor';

type StepDescriptorContainer = Partial<{
  [T in InteractionStepType]: StepDescriptor<T>;
}>;

export const StepDescriptors: StepDescriptorContainer = {};

export const getStepDescriptorByType = <T extends InteractionStepType = InteractionStepType>(
  type?: T,
): StepDescriptor<T> | undefined => {
  if (!type) return undefined;
  return StepDescriptors[type];
};

type RegisterStepDescriptorParams<T extends InteractionStepType = InteractionStepType> = {
  type: T;
  descriptor: StepDescriptor<T>;
};

export const registerStepDescriptor = <T extends InteractionStepType = InteractionStepType>({
  type,
  descriptor,
}: RegisterStepDescriptorParams<T>) => {
  if (StepDescriptors[type]) {
    throw new Error(`StepDescriptor for ${type} already registered`);
  }
  StepDescriptors[type] = descriptor as any;
};
